<template>
  <div class="small d-flex align-items-center">
    <span>Show</span>

    <b-form-select
      :value="pageSize"
      :options="pageSizeOptions"
      size="sm"
      class="mx-2"
      @input="(newPageSize) => setPageSize(newPageSize)"
    ></b-form-select>

    <span>entries</span>
  </div>
</template>

<script>
import { defineComponent, inject } from '@vue/composition-api'

import { BaseDataTableInjectionKey } from './BaseDataTable.constants'

export default defineComponent({
  name: 'BaseDataTablePageSizeSelect',
  setup() {
    const { pageSize, setPageSize, pageSizeOptions } = inject(
      BaseDataTableInjectionKey
    )

    return {
      pageSizeOptions,

      pageSize,
      setPageSize
    }
  }
})
</script>

<style scoped>
.custom-select {
  width: 60px;
}
</style>
